import { RealmSelector } from './components/RealmSelector';

const isProduction = window.location.host === 'app.scriptrunnerconnect.com';
const isStaging = window.location.host === 'stg.scriptrunnerconnect.com';

/** Dev staff URL: scriptrunnerconnect.<user>.staff.adaptavist.net → derive <user> for src-ui links. */
const devStaffUser = window.location.hostname.match(/^scriptrunnerconnect\.([^.]+)\.staff\.adaptavist\.net$/)?.[1];

const queryParams = window.location.search;
const urlPath = window.location.pathname;

const euAppUrl = isProduction
    ? 'https://app.eu.scriptrunnerconnect.com'
    : isStaging
      ? 'https://eu.stg.scriptrunnerconnect.com'
      : `https://scriptrunnerconnect.eu.${devStaffUser}.staff.adaptavist.net`;

const usAppUrl = isProduction
    ? 'https://app.us.scriptrunnerconnect.com'
    : isStaging
      ? 'https://eu.stg.scriptrunnerconnect.com' // No US deployment
      : `https://scriptrunnerconnect.eu.${devStaffUser}.staff.adaptavist.net`; // No US deployment

export const RealmSelectorContainer: React.FC = () => {
    return <RealmSelector euAppUrl={euAppUrl} queryParams={queryParams} urlPath={urlPath} usAppUrl={usAppUrl} />;
};
